import api from './api'

// Billing endpoints exist only while PAYMENTS_ENABLED is true on the backend.
export const billingApi = {
  getPlans: () => api.get('/v1/billing/plans').then((r) => r.data.plans),
  // origin: Stripe redirects back to the origin the user checked out from
  // (tokens are per-origin — dev server vs staging vs production).
  checkout: (tier) =>
    api
      .post('/v1/billing/checkout', { tier, origin: window.location.origin })
      .then((r) => r.data),
  acceptTerms: () => api.post('/v1/auth/terms/accept').then((r) => r.data),
}

export default billingApi
